import { render } from "./CoffeeTithTarvhmallow.vue?vue&type=template&id=b8e12f52"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CoffeeTithTarvhmallow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8e12f52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8e12f52', __exports__)) {
    api.reload('b8e12f52', __exports__)
  }
  
  module.hot.accept("./CoffeeTithTarvhmallow.vue?vue&type=template&id=b8e12f52", () => {
    api.rerender('b8e12f52', render)
  })

}


export default __exports__